import React from 'react';
import { Card, InputGroup, FormControl, Button, Modal } from 'react-bootstrap';
import MaterialTable from "material-table";
import '../App.css';

function Config() {
  const url = "/api";
  const token = localStorage.getItem('token');
  const [newThreshold, setThreshold] = React.useState({
    ident: localStorage.getItem('detSelected'),
    cpuTempTh: '',
    cpuTh: '',
    memTh: '',
    diskTh: '',
    responseTimeTh: ''
  });
  const [thRows, setThRows] = React.useState([]);

  const thColumns = [
    {
      title: "Name",
      field: "name",
      align: 'center',
    },
    {
      title: "CPU Temperature",
      field: "cpuTemp",
      align: 'center',
    },
    {
      title: "CPU Usage",
      field: "cpu",
      align: 'center',
    },
    {
      title: "Memory Usage",
      field: "mem",
      align: 'center',
    },
    {
      title: "Disk Usage",
      field: "disk",
      align: 'center',
    },
    {
      title: "Response Time",
      field: "responseTime",
      align: 'center',
    },
  ]

  async function computeThreshold() {
    let optionsThreshold = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
        'x-access-token': token
      }
    }
    let responseTh = await fetch(url + '/allThresholds', optionsThreshold).catch(err => {
      console.log(err);
    });
    if (responseTh.status !== 200) {
      console.log("Can't get the threshold information");
    }
    var thDataReceived = await responseTh.json();
    var rows = [];
    thDataReceived.forEach(threshold => {
      rows.push({
        name: threshold.ident,
        cpuTemp: threshold.cpuTempTh,
        cpu: threshold.cpuTh,
        mem: threshold.memTh,
        disk: threshold.diskTh,
        responseTime: threshold.responseTimeTh
      })
    });

    return (rows)
  }

  function editCpuTempTh(event) {
    setThreshold({
      ident: newThreshold.ident,
      cpuTempTh: event.target.value,
      cpuTh: newThreshold.cpuTh,
      memTh: newThreshold.memTh,
      diskTh: newThreshold.diskTh,
      responseTimeTh: newThreshold.responseTimeTh
    });
  }

  function editCpuTh(event) {
    setThreshold({
      ident: newThreshold.ident,
      cpuTempTh: newThreshold.cpuTempTh,
      cpuTh: event.target.value,
      memTh: newThreshold.memTh,
      diskTh: newThreshold.diskTh,
      responseTimeTh: newThreshold.responseTimeTh
    });
  }

  function editDiskTh(event) {
    setThreshold({
      ident: newThreshold.ident,
      cpuTempTh: newThreshold.cpuTempTh,
      cpuTh: newThreshold.cpuTh,
      memTh: newThreshold.memTh,
      diskTh: event.target.value,
      responseTimeTh: newThreshold.responseTimeTh
    });
  }

  function editMemTh(event) {
    setThreshold({
      ident: newThreshold.ident,
      cpuTempTh: newThreshold.cpuTempTh,
      cpuTh: newThreshold.cpuTh,
      memTh: event.target.value,
      diskTh: newThreshold.diskTh,
      responseTimeTh: newThreshold.responseTimeTh
    });
  }

  function editIdentTh(event) {
    setThreshold({
      ident: event.target.value,
      cpuTempTh: newThreshold.cpuTempTh,
      cpuTh: newThreshold.cpuTh,
      memTh: newThreshold.memTh,
      diskTh: newThreshold.diskTh,
      responseTimeTh: newThreshold.responseTimeTh
    });
  }

  function editResponseTimeTh(event){
    setThreshold({
      ident: newThreshold.ident,
      cpuTempTh: newThreshold.cpuTempTh,
      cpuTh: newThreshold.cpuTh,
      memTh: newThreshold.memTh,
      diskTh: newThreshold.diskTh,
      responseTimeTh: event.target.value
    });
  }

  async function saveNewThreshold() {
    const userLogged = localStorage.getItem("Login");
    const toJson = {
      "cpuTempTh": newThreshold.cpuTempTh,
      "cpuTh": newThreshold.cpuTh,
      "memTh": newThreshold.memTh,
      "diskTh": newThreshold.diskTh,
      "responseTimeTh": newThreshold.responseTimeTh,
      "user": userLogged,
    }
    console.log(toJson);
    let options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
        'x-access-token': token
      },
      body: JSON.stringify(toJson)
    }

    let response = await fetch(url + '/threshold/' + newThreshold.ident, options).catch(err => {
      console.log(err);
    });

    if (response.status !== 200) {
      if (response.status === 401) {
        localStorage.removeItem('token');
      }
      console.log("The threshold can't be updated");
      alert("The threshold can't be updated :(")
    }
    var dataReceived = await response.json();
    console.log("Threshold updated" + dataReceived);
    const rows = await computeThreshold();
    setThRows(rows);
  }

  async function deleteThreshold(id) {
    let optionsThreshold = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
        'x-access-token': token
      }
    }
    let responseTh = await fetch(url + '/threshold/' + id, optionsThreshold).catch(err => {
      console.log(err);
    });
    if (responseTh.status !== 200) {
      console.log("Can't delete the threshold");
    }
    var thDataReceived = await responseTh.json();
    console.log(thDataReceived);
    const rows = await computeThreshold();
    setThRows(rows);;
  }

  React.useEffect(() => {
    async function fetchThreshold() {
      const rows = await computeThreshold();
      setThRows(rows);
    }
    fetchThreshold();
  }
    , []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <h1>Configuration</h1>
      <br></br>
      <br></br>
      <hr></hr>
      <div style={{ paddingTop: '20px', display: "flex", flexDirection: "column" }}>
        <div style={{ paddingTop: '20px', display: "flex", flexDirection: "row" }}>
          <Card style={{ marginTop: '10px', paddingLeft: "20px", paddingRight: "50px", paddingTop: "30px", paddingBottom: "40px", borderRadius: '20px' }}>
            <Card.Body>
              <Card.Title><strong>New / Edit Threshold</strong></Card.Title>
              <br></br>
              <br></br>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">Identifier (detector ID)</InputGroup.Text>
                <FormControl placeholder=""
                  value={newThreshold.ident}
                  aria-label="ident"
                  aria-describedby="basic-addon1"
                  onChange={editIdentTh}></FormControl>

              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">CPU Temperature</InputGroup.Text>
                <FormControl placeholder=""
                  value={newThreshold.cpuTempTh}
                  aria-label="cpuTemp"
                  aria-describedby="basic-addon1"
                  onChange={editCpuTempTh}></FormControl>

                <InputGroup.Text id="basic-addon1">ºC</InputGroup.Text>
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">CPU Usage</InputGroup.Text>
                <FormControl
                  placeholder=""
                  value={newThreshold.cpuTh}
                  aria-label="cpu"
                  aria-describedby="basic-addon1"
                  onChange={editCpuTh}
                />
                <InputGroup.Text id="basic-addon1">%</InputGroup.Text>
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">Memory Usage</InputGroup.Text>
                <FormControl
                  placeholder=""
                  value={newThreshold.memTh}
                  aria-label="mem"
                  aria-describedby="basic-addon1"
                  onChange={editMemTh}
                />
                <InputGroup.Text id="basic-addon1">%</InputGroup.Text>
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">Disk Usage</InputGroup.Text>
                <FormControl
                  placeholder=""
                  value={newThreshold.diskTh}
                  aria-label="disk"
                  aria-describedby="basic-addon1"
                  onChange={editDiskTh}
                />
                <InputGroup.Text id="basic-addon1">%</InputGroup.Text>
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">Response Time</InputGroup.Text>
                <FormControl
                  placeholder=""
                  value={newThreshold.responseTimeTh}
                  aria-label="disk"
                  aria-describedby="basic-addon1"
                  onChange={editResponseTimeTh}
                />
                <InputGroup.Text id="basic-addon1">ms</InputGroup.Text>
              </InputGroup>
              <div style={{ textAlign: 'center', marginTop: '40px' }}>
                <Button variant="primary" style={{ backgroundColor: '#076129', borderColor: '#076129' }} onClick={saveNewThreshold}>Save</Button>
              </div>
            </Card.Body>
          </Card>
          <Card style={{ marginTop: '10px', marginLeft: "20px", paddingRight: "50px", paddingTop: "50px", paddingBottom: "40px", paddingLeft: '40px' , borderRadius: '20px'}}>
            <MaterialTable
              title="Threshold Values"
              data={thRows}
              columns={thColumns}
              options={{ search: true, paging: true, headerStyle: { fontSize: '1em', paddingLeft: '30px' }, pageSizeOptions: [5, 10, 20], pageSize: 5 }}
              style={{ textAlign: 'center' , borderRadius: '20px'}}
              localization={
                {
                  root: {
                    display: 'flex',
                    overflowX: 'hide',
                  }
                },
                {
                  header: {
                    actions: ""
                  }
                }
              }
              actions={[
                {
                  icon: 'edit',
                  tooltip: 'Edit Threshold',
                  onClick: (event, rowData) => {
                    setThreshold({
                      ident: rowData.name,
                      cpuTempTh: rowData.cpuTemp,
                      cpuTh: rowData.cpu,
                      memTh: rowData.mem,
                      diskTh: rowData.disk,
                      responseTimeTh: rowData.responseTime
                    });
                  }
                },
                {
                  icon: 'delete',
                  tooltip: 'Delete Threshold',
                  onClick: (event, rowData) => {
                    if (rowData.name !== 'GENERAL') {
                      deleteThreshold(rowData.name)
                    } else {
                      window.alert("You can't delete the GENERAL threshold")
                    }
                  }
                }
              ]}
            />
          </Card>
        </div>
      </div>
    </div>
  );



}

export default Config;
